module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "2vw",
      "color": "rgb(26,188,156)",
      "text-align": "center"
    }
  }, [(_vm.formatUSD(_vm.globalRevenueSummary.today_revenue) !== 'n/a') ? _c('span', [_vm._v(_vm._s(_vm.formatUSD(_vm.globalRevenueSummary.today_revenue)) + " in ")]) : _vm._e(), _vm._v(_vm._s(_vm.formatNumber(_vm.top10globalItems.daily_order)) + " orders")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "2vw",
      "color": "#3498db",
      "text-align": "center"
    }
  }, [(_vm.formatUSD(_vm.globalRevenueSummary.week_revenue) !== 'n/a') ? _c('span', [_vm._v(_vm._s(_vm.formatUSD(_vm.globalRevenueSummary.week_revenue)) + " in ")]) : _vm._e(), _vm._v(_vm._s(_vm.formatNumber(_vm.top10globalItems.weekly_order)) + " orders")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "2vw",
      "color": "#e67e22",
      "text-align": "center"
    }
  }, [(_vm.formatUSD(_vm.globalRevenueSummary.month_revenue) !== 'n/a') ? _c('span', [_vm._v(_vm._s(_vm.formatUSD(_vm.globalRevenueSummary.month_revenue)) + " in ")]) : _vm._e(), _vm._v(_vm._s(_vm.formatNumber(_vm.top10globalItems.monthly_order)) + " orders")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "2vw",
      "color": "#9b59b6",
      "text-align": "center"
    }
  }, [(_vm.formatUSD(_vm.globalRevenueSummary.year_revenue) !== 'n/a') ? _c('span', [_vm._v(_vm._s(_vm.formatUSD(_vm.globalRevenueSummary.year_revenue)) + " in ")]) : _vm._e(), _vm._v(_vm._s(_vm.formatNumber(_vm.top10globalItems.yearly_order)) + " orders")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "2vw",
      "color": "#F2B230",
      "text-align": "center"
    }
  }, [(_vm.formatUSD(_vm.globalRevenueSummary.total_revenue) !== 'n/a') ? _c('span', [_vm._v(_vm._s(_vm.formatUSD(_vm.globalRevenueSummary.total_revenue)) + " in ")]) : _vm._e(), _vm._v(_vm._s(_vm.formatNumber(_vm.top10globalItems.total_order)) + " orders")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('el-select', {
    staticClass: "pull-right full-width",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Select store"
    },
    on: {
      "change": _vm.updateLocations
    },
    model: {
      value: (_vm.selectedLocations),
      callback: function($$v) {
        _vm.selectedLocations = $$v
      },
      expression: "selectedLocations"
    }
  }, _vm._l((_vm.stores), function(store) {
    return _c('el-option', {
      key: store.value,
      attrs: {
        "label": store.label,
        "value": store
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-1 margin-top-10 center"
  }, [_c('el-radio-group', {
    on: {
      "change": function($event) {
        _vm.weekSelected()
      }
    },
    model: {
      value: (_vm.searchPeriod),
      callback: function($$v) {
        _vm.searchPeriod = $$v
      },
      expression: "searchPeriod"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }, [_vm._v("week")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("custom")])], 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchPeriod === 'custom'),
      expression: "searchPeriod === 'custom'"
    }],
    attrs: {
      "editable": false,
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "From"
    },
    on: {
      "change": function($event) {
        _vm.dateFromSelected()
      }
    },
    model: {
      value: (_vm.from_date),
      callback: function($$v) {
        _vm.from_date = $$v
      },
      expression: "from_date"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchPeriod === 'custom'),
      expression: "searchPeriod === 'custom'"
    }],
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "To"
    },
    on: {
      "change": function($event) {
        _vm.dateToSelected()
      }
    },
    model: {
      value: (_vm.to_date),
      callback: function($$v) {
        _vm.to_date = $$v
      },
      expression: "to_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "chart_div"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(6, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.mostRecentOrders
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "row-expansion"
        }, [_c('p', {
          staticClass: "row-expansion-data"
        }, [_vm._v("Total spent: " + _vm._s(_vm.formatUSD(props.row.user.total_spent)))]), _vm._v(" "), _c('p', {
          staticClass: "row-expansion-data"
        }, [_vm._v("No. of orders: " + _vm._s(props.row.user.total_orders))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.email",
      "label": "User",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Amount",
      "formatter": _vm.tableFormatUSD,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "location_name",
      "label": "Store",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "filters": [{
        text: 'pending',
        value: 'pending'
      }, {
        text: 'completed',
        value: 'completed'
      }, {
        text: 'overdue',
        value: 'overdue'
      }, {
        text: 'cancelled',
        value: 'cancelled'
      }, {
        text: 'refunded',
        value: 'refunded'
      }],
      "filter-method": _vm.filterTag,
      "filter-placement": "bottom-end",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          class: {
            'status-pending': scope.row.status === 'pending', 'status-completed': scope.row.status === 'completed', 'status-overdue': scope.row.status === 'overdue', 'status-cancelled': scope.row.status === 'cancelled', 'status-refunded': scope.row.status === 'refunded'
          }
        }, [_vm._v(_vm._s(scope.row.status))])]
      }
    }])
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "rgb(26,188,156)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-usd fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tToday\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#3498db",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-usd fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tWeek\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#e67e22",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-usd fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tMonth\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#9b59b6",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-usd fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tYear\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#F2B230",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-usd fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tTotal\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#409EFF",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-line-chart fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tRevenue Tracker\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#95a5a6",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-list-ol fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tMost Recent Orders\n\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc6775fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Analytics/Overview.vue
// module id = 796
// module chunks = 0